export const SearchConf = {
  query: {
    keys: [
      {
        key: 'id_item.name_ITA',
        operator: '$containsi',
      },
      {
        key: 'id_item.name_ENG',
        operator: '$containsi',
      },
      {
        key: 'note',
        operator: '$containsi',
      },
      {
        key: 'internal_note',
        operator: '$containsi',
      },
      {
        key: 'id_logbook.id_supplier.mexal_code',
        operator: '$containsi',
      },
      {
        key: 'id_logbook.id_supplier.company_name',
        operator: '$containsi',
      },
      {
        key: 'id_logbook.status_logbook',
        operator: '$containsi',
      },
      {
        key: 'available',
        operator: '$containsi',
      },
    ],
  },
  placeholder: 'Search ',
  initialState: {
    value: '',
  },
};
